
































































































import moment from 'moment';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';
import { Transition } from '@/models/transition';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '../common/ErrorAlert.vue';
import auth from '@/mixins/auth';
import colorable from '@/mixins/colorable';
import mixins from '@/utils/mixins';
import {
  IPayrollChangeRequest,
  PayrollChangeRequestStatus,
  PayrollChangeRequestStatusEnum
} from '@/models';
import { PropType } from 'vue';
import { AxiosError } from 'axios';

export default mixins(auth, colorable).extend({
  components: { ErrorAlert },
  name: 'PayrollChangeRequestDetailActivityCard',

  props: {
    payrollChangeRequest: {
      type: Object as PropType<IPayrollChangeRequest>,
      required: true
    }
  },

  data: () => ({
    loading: false,

    errorMessage: '',
    detailErrorMessage: '',
    currentTab: 0
  }),

  computed: {
    payrollChangeRequestActivities: get<Transition[]>(
      'payrollChangeRequest/getPayrollChangeRequestActivities'
    ),

    PayrollChangeRequestStatus: () => PayrollChangeRequestStatus
  },

  methods: {
    timeFromNow: (date: Date | string) => {
      return moment(date).fromNow();
    },

    ...mapActions({
      fetchPayrollChangeRequestActivities:
        'payrollChangeRequest/fetchPayrollChangeRequestActivities'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    //TODO: this should be from the PayrollChangeRequestStatus model
    getStatusMessage(status: number): string {
      const stateMessage = new PayrollChangeRequestStatus({
        value: status
      }).getCurrentState().message!;
      return stateMessage;
    }
  },

  async mounted() {
    this.loading = true;
    try {
      await this.fetchPayrollChangeRequestActivities(
        this.payrollChangeRequest.id
      );
    } catch (err) {
      const error = err as AxiosError;
      if (error.response) {
        if (error.response.data.detail) {
          this.detailErrorMessage = error.response.data.detail;
        }
      }
      this.errorMessage = ErrorManager.extractApiError(error);
    } finally {
      this.loading = false;
    }
  }
});
